function isChromiumBased() {
    // @ts-ignore : exists for chromium based browsers
    return !!window.chrome;
}

export { isChromiumBased };
//# sourceMappingURL=index.js.map
